import { memo } from 'react';
import { cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import InfoBlockIcon from './icons/InfoBlockIcon';
import InfoBlockIcon2 from './icons/InfoBlockIcon2';
import InfoBlockIcon3 from './icons/InfoBlockIcon3';
import styles from './InfoBlocks.module.css';

import type { FC, HTMLAttributes } from 'react';

interface InfoBlocksProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const InfoBlocks: FC<InfoBlocksProps> = (props) => {
  const { className, ...restProps } = props;
  const { t } = useTranslation();

  return (
    <div {...restProps} className={cn(styles.wrapper, className)}>
      <div className={styles.title}>{t('info.title')}</div>
      <div className={styles.infoBlocks}>
        <div className={styles.block}>
          <InfoBlockIcon className={styles.icon} />
          <div className={styles.description}>{t('info.blocks.1')}</div>
        </div>
        <div className={styles.block}>
          <InfoBlockIcon2 className={styles.icon} />
          <div className={styles.description}>{t('info.blocks.2')}</div>
        </div>
        <div className={styles.block}>
          <div className={styles.block}>
            <InfoBlockIcon3 className={styles.icon} />
            <div className={styles.description}>{t('info.blocks.3')}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(InfoBlocks);
